<template>
    <el-upload
        class="upload-demo"
        :action="upLoadUrl + '?groupNumber=' + upData.groupNumber"
        :on-preview="uphandlePreview"
        :on-remove="uphandleRemove"
        :on-success="uphandleSuccess"
        :before-remove="upbeforeRemove"
        multiple
        list-type="picture-card"
        :file-list="fileList"
        >
        <el-button size="small" type="primary">点击上传</el-button>             
    </el-upload>
</template>

<script>
    import { ref, reactive, toRefs, getCurrentInstance, onBeforeMount, watch } from 'vue'
    import { ElMessage } from 'element-plus'
    
    export default {
        name: 'UpLoad',
        props: {
            fileList: {
                type: Array,
                value: []
            },
            groupId: {
                type: String,
                value: ''
            }
        },
        setup(props, context) {
            let { proxy } = getCurrentInstance()
            // 上传附件
            let uploadInfo = reactive({
                upLoadUrl: '/meide/REST/fileUpLoad',
                fileList: props.fileList, // 已上传的文件列表
                upData: {
                    groupNumber: props.groupId, // 要上传的GID
                }
            })
            watch(props, (newProps, oldProps) => {
                uploadInfo.upData.groupNumber = newProps.groupId
                uploadInfo.fileList = newProps.fileList
            })
            // 文件列表移除文件时的钩子
            let uphandleRemove = (file, fileList) => {
                
                // if(fileList.length = 0) {}
            }
            // 点击文件列表中已上传文件时的钩子
            let uphandlePreview = (file) => {
                // 下载
            }
            // 文件上传成功
            let uphandleSuccess = (response, file, fileList) => {
                uploadInfo.upData.groupNumber = response.GID
                context.emit('groupIdSend', uploadInfo.upData.groupNumber)
            }
            // 删除文件之前的钩子
            let upbeforeRemove = (file, fileList) => {
                return new Promise((resolve, reject) => {
                    proxy.$confirm('是否要删除此附件？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        callback: action => {
                            if(action == 'cancel') {
                                ElMessage({
                                    showClose: true,
                                    message: '已取消删除'
                                })
                                return reject(false)
                            }else {
                                let data = null
                                if(file.response) {
                                    data = {
                                        postType: 'removeFile',
                                        GPFILENAME: file.response.FID
                                    }
                                }else {
                                    data = {
                                        postType: 'removeFile',
                                        GPFILENAME: file.FID
                                    }
                                }
                                
                                proxy.$axios.postReq('/meide/REST/ProblemCloseSub', data)
                                .then(res => {
                                    if(res.success == 'true') {
                                        ElMessage.success({
                                            message: res.Info,
                                            type: 'success'
                                        })
                                        return resolve(true)
                                    }else {
                                        proxy.$alert(res.ErrorText, '提示', {
                                            confirmButtonText: '确定',
                                            callback: action => {}
                                        })
                                        return reject(false)
                                    }
                                }).catch(error => {
                                    proxy.$alert(error, '提示', {
                                        confirmButtonText: '确定',
                                        callback: action => {}
                                    })
                                    return reject(false)
                                })
                            }
                        }
                    })
                })
            }
           
            return {
                ...toRefs(uploadInfo),
                uphandleRemove,
                uphandlePreview,
                upbeforeRemove,
                uphandleSuccess,
            }
        }
    }
</script>

<style scoped lang="scss">
    .popcon {
        width: 580px;
        background: #fff;
        h3 {
            background: rgba(242, 242, 242, 1);
            font-weight: bold;
            padding: 15px 20px;
            font-size: 16px;
            color: #666;
            margin-bottom: 15px;
            span {
                float: right;
                font-weight: bolder;
                font-size: 20px;
                margin-top: -5px;
                cursor: pointer;
            }
        }
        ::v-deep(.el-form ){
            padding: 0 20px;
            .el-input--small .el-input__inner {
                width: 165px;
            }
            .longinput .el-input--small .el-input__inner, .longinput .el-textarea__inner {
                width: 400px;
            }
            .block {
                width: 100%;
                text-align: right;
            }
        }
    }
</style>